import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.employedIn;

const getEmployedIn = createSelector(getData, employedIn => values(employedIn));

export default getEmployedIn;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getEmployedIn.js